import axios from 'axios';
import { reportBackendReachable, reportBackendUnreachable } from './connectivity';

const quarkusApi = axios.create({
  baseURL: process.env.REACT_APP_QUARKUS_API_URL,
  timeout: 30000,
});

// Detecta se o backend está respondendo, alimentando o store de conectividade.
// Qualquer resposta HTTP (mesmo 4xx/5xx) prova que o servidor está de pé.
// Erro sem `response` (timeout, rede, DNS) = servidor não respondeu.
quarkusApi.interceptors.response.use(
  (response) => {
    reportBackendReachable();
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    if (error.response) {
      reportBackendReachable();
    } else {
      reportBackendUnreachable();
    }
    return Promise.reject(error);
  },
);

export default quarkusApi;
